// @flow
import React, { type Node } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Table, Tr, Th } from 'app/common/ui-components/table';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import type { Period } from '../usePeriods';
import styles from './TableSummaryHead.scss';


type Props = {
  className?: string,
  periods: Array<Period>
}

const TableSummaryHead = ({ className, periods }: Props): Node => {
  const { t } = useTranslation('dnevnik');
  const head = t('column_subjects1');
  const year = t('by_year');

  const thProps = {
    className: styles.th,
    contentClassName: styles.thContent,
    stripPadding: true,
  };

  return (
    <Table className={cn(styles.root, className)}>
      <thead>
        <Tr header>
          <Th {...thProps}>
            <PlainTooltip text={head} hideWithoutOverflow>
              {head}
            </PlainTooltip>
          </Th>

          {periods.map(({ title }) => (
            <Th {...thProps} key={title}>
              <PlainTooltip text={title} hideWithoutOverflow>
                {title}
              </PlainTooltip>
            </Th>
          ))}

          <Th {...thProps}>
            <PlainTooltip text={year} hideWithoutOverflow>
              {year}
            </PlainTooltip>
          </Th>
        </Tr>
      </thead>
    </Table>
  );
};

export default TableSummaryHead;
